import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-anchor/jb-anchor.css.ts
var jb_anchor_css_default = i`a{--_additional-spacing-block: max(calc((var(--minimum-touch-target-height, 24px) - 1lh) / 2), 0px);display:inline-block;margin-block:calc(-1*var(--_additional-spacing-block));padding-block:var(--_additional-spacing-block)}a{display:inline-block;isolation:isolate;position:relative}a::before{block-size:100%;content:"";inline-size:var(--minimum-touch-target-width, 24px);inset-block-start:0;inset-inline-start:50%;pointer-events:auto;position:absolute;transform:translateX(-50%);z-index:-1}:host{color:inherit;display:block;font:inherit;position:relative}a.inactive{cursor:default;opacity:.4;pointer-events:none}`;

export {
  jb_anchor_css_default
};
